import type { GameFragment } from "../types";

export type SearchResultItem =
  | ({ __typename: "CasinoGameInventoryGame" } & GameFragment)
  | {
      __typename: "CasinoGameInventoryProviderGroup";
      games?: (GameFragment | null)[] | null;
    };

const normalizeGamesResponse = (
  results: (SearchResultItem | null | undefined)[] | null | undefined,
): GameFragment[] => {
  return (results || []).flatMap((item) => {
    if (!item) return [];
    if (item.__typename === "CasinoGameInventoryProviderGroup") {
      return (item.games || []).filter((game): game is GameFragment =>
        Boolean(game),
      );
    }
    return [item];
  });
};

export default normalizeGamesResponse;
